import React from "react";
import FormInput from "./FormInput";
import { useTranslation } from "react-i18next";
export default function ProfileRow({

    label,
    icon,
    type = "text",
    name,
    value,
    placeholder = "",
    readOnly = false,
    disabled = false,
    error,
    onChange,
    options = [],
    optionValue = "id",
    optionLabel = "label",
    rows = 3,
    required = false,
    helpText = "",
    maxLength,
    col = "col-12"  // <-- même lignes

}) {
return (

    <div className={col}>

        <div className="row profile-row align-items-start mb-3">
            <label className="col-lg-3 col-md-4 profile-label pt-2">

                {icon &&
                    <i className={`bi ${icon} me-2`}></i>
                }

                {label}

            </label>

            <div className="col-lg-9 col-md-8">

                <FormInput

                    type={type}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    disabled={disabled}
                    error={error}
                    onChange={onChange}
                    options={options}
                    optionValue={optionValue}
                    optionLabel={optionLabel}
                    rows={rows}
                    required={required}
                    helpText={helpText}
                    maxLength={maxLength}

                />

            </div>

        </div>

    </div>

);
}